export const ROW_SELECTION = 'row____selection'

export const CLASSNAME_PREFIX = 'editable-table'
